import React, { useEffect, useState, useRef } from "react";
import "./ManageStore.css";
import axios from "axios";
import SelectStore from "./SelectStore.tsx";
import { toast } from "../../components/Toast/toast.ts";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import crossIcon from "../../assets/crossIcon.png";
import associatePic from "../../assets/associatePic.png";
import storeAssociateIcon from "../../assets/storeAssociate.png";
import sendReportIcon from "../../assets/sendReport.png";
import EastIcon from "@mui/icons-material/East";
import liveEyeIcon from "../../assets/images/liveEyeIcon.png";
import { ProgressSpinner } from "primereact/progressspinner";
import DescriptionBox from "../../components/DescriptionBox/index.tsx";
import AppButton from "../../components/ui/AppButton.tsx";

const ManageStore: React.FC = () => {
  const [storeAssociates, setStoreAssociates] = useState([]);
  const storedToken = localStorage.getItem("token");
  const EmailInput: any = useRef(null);
  const messageInput: any = useRef(null);
  const [storesFetched, setStoresFetched] = useState([]);
  const [reloadComponent, setReloadComponent] = useState(false);
  const [selectedStores, setSelectedStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rightLoader, setRightLoader] = useState(false);
  const [sendBtnText, setSendBtnText] = useState(false);
  const [associateInfo, setAssociateInfo] = useState<any>([]);

  const handleSelectionChange = (selectedStoreIds: any) => {
    setSelectedStores(selectedStoreIds);
  };
  useEffect(() => {
    const fetchStoreAssociateInfo = async () => {
      if (storedToken) {
        try {
          setLoading(true);
          let response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/stores`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            },
          );
          setStoreAssociates(response?.data);
          setStoresFetched(response?.data);
          setLoading(false);
        } catch (error: any) {
          toast.error(
            error?.response?.data?.message || "Something went wrong!",
          );
          setLoading(false);
        }
      }
    };
    fetchStoreAssociateInfo();
    // eslint-disable-next-line
  }, [reloadComponent]);

  const handleSendingStoreReportAccess = async () => {
    if (storedToken) {
      try {
        setRightLoader(true);
        const email = EmailInput?.current?.value;
        const message = messageInput?.current?.value;
        const role = "associate";

        const payload = {
          stores: selectedStores,
          email,
          message,
          role,
        };
        const response: any = await axios.put(
          `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/associate`,
          payload,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          },
        );
        if (response?.status === 200) {
          // Reload the component by updating reloadComponent state
          setReloadComponent((prevState) => !prevState);
          toast.success(response?.message);
          setRightLoader(false);
          // console.log(response?.message);
        }
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
        setRightLoader(false);
      }
    }
  };

  async function populateData(id: number) {
    try {
      setRightLoader(true);
      setSendBtnText(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/associate/${id}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );
      setAssociateInfo(response?.data);
      if (response?.data) {
        let selected = response?.data?.stores?.map((item: any) => item._id);
        // let selected=response?.data?.stores?.map((item)=> item._id)
        setSelectedStores(selected);
        toast.success("Associate Details Loaded Successfully");
        setRightLoader(false);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An error occurred. Please try again.",
      );
      setRightLoader(false);
    }
  }

  const handleMinusButton = (storeId: any, associateId: any) => {
    RemoveAssociate(storeId, associateId);
  };

  async function RemoveAssociate(storeId: number, associateId: number) {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${process.env.REACT_APP_API_URL}/api/cust-portal/customer/associate/${associateId}/${storeId}`,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        },
      );
      // console.log(response)
      if (response?.status === 200) {
        // Reload the component by updating reloadComponent state
        toast.success(response?.data?.message);
        setLoading(false);
        setReloadComponent((prevState) => !prevState);
      }
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Something went wrong!",
      );
      setLoading(false);
    }
  }

  const inputClass = `
  w-full h-[38px] rounded-md px-3
  border border-[rgb(var(--border-primary))]
  bg-[rgb(var(--surface-2))]
  text-[12px] text-[rgb(var(--text-primary))]
  placeholder:text-[rgb(var(--text-muted))]
  focus:shadow-none focus:border-[rgba(212,168,74,0.5)]
  transition-colors duration-200
  disabled:opacity-40 disabled:cursor-not-allowed
`;

  const labelClass = `
  text-[10px] font-semibold uppercase tracking-[0.07em]
  text-[rgb(var(--text-muted))]
`;

  return (
    <div
      className="
      w-full
      relative
    "
    >
      {/* GRID */}
      <div
        className="
        relative
        z-[2]
        grid
        grid-cols-1
        xl:grid-cols-[1.1fr_0.9fr]
        gap-6
      "
      >
        {/* ========================================= */}
        {/* LEFT PANEL */}
        {/* ========================================= */}

        <div
          className="
          card
          overflow-hidden
          transition-all
          duration-500
          hover:shadow-[var(--shadow-card-hover)]
        "
        >
          <DescriptionBox
            title="MANAGE STORES"
            subTitle="Store Associates"
            description="Manage all associated stores & users"
          />

          {/* Body */}
          <div className="mt-4">
            {loading ? (
              <div
                className="
                flex
                items-center
                justify-center
                py-20
              "
              >
                <ProgressSpinner
                  style={{
                    width: "60px",
                    height: "60px",
                  }}
                  strokeWidth="2"
                />
              </div>
            ) : (
              <div className="flex flex-col gap-3">
                {storeAssociates?.map((item: any, index) => (
                  <div
                    key={index}
                    className="
                    group
                    card
                    p-2.5
                    bg-[rgb(var(--surface-2))]
                    transition-all
                    duration-300
                    hover:-translate-y-1
                    hover:border-[rgba(212,168,74,0.25)]
                  "
                  >
                    {/* TOP */}
                    <div className="flex items-start justify-between">
                      <div className="flex items-center gap-4">
                        <div
                          className="
                          w-10
                          h-10
                          rounded-md
                          flex
                          items-center
                          justify-center
                          bg-[rgba(212,168,74,0.12)]
                          border
                          border-[rgba(212,168,74,0.18)]
                        "
                        >
                          <img
                            src={liveEyeIcon}
                            alt="liveEyeIcon"
                            className="w-5 object-contain"
                          />
                        </div>

                        <div>
                          <div className="card-title">{item?.name}</div>

                          <div className="card-subtitle">
                            {item?.city}, {item?.state}
                          </div>
                        </div>
                      </div>

                      {item?.zoho_invoice?.unpaid_invoices_balance && (
                        <div>
                          <span
                            className={`
                          px-3
                          py-1.5
                          rounded-full
                          text-[10px]
                          uppercase
                          tracking-[0.15em]
                          font-semibold
                          ${
                            item?.zoho_invoice?.unpaid_invoices_balance ===
                            "Paid"
                              ? "bg-[rgba(45,138,95,0.14)] text-[rgb(var(--success))]"
                              : item?.zoho_invoice?.unpaid_invoices_balance ===
                                  "Un-Paid"
                                ? "bg-[rgba(184,56,56,0.14)] text-[rgb(var(--danger))]"
                                : "bg-[rgb(var(--surface-3))] text-[rgb(var(--text-muted))]"
                          }
                        `}
                          >
                            {item?.zoho_invoice?.unpaid_invoices_balance || ""}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Associates */}
                    <div className="mt-2 flex flex-col gap-1.5">
                      {item?.associates?.map((associate: any) => (
                        <div
                          key={associate._id}
                          className="
                          flex
                          items-center
                          justify-between
                          rounded-md
                          bg-[rgb(var(--surface-1))]
                          border
                          border-[rgb(var(--border-primary))]
                          px-3
                          py-1.5
                          transition-all
                          duration-300
                          hover:border-[rgba(212,168,74,0.18)]
                        "
                        >
                          <div className="flex items-center gap-3 min-w-0">
                            <img
                              src={associatePic}
                              alt="associatePic"
                              className="w-4 h-4 object-contain"
                            />

                            <span
                              onClick={() => populateData(associate._id)}
                              className="
                              table-cell
                              truncate
                              cursor-pointer
                              hover:text-[rgb(var(--color-gold-1))]
                              transition-colors
                            "
                            >
                              {associate.firstName} {associate.lastName}
                            </span>
                          </div>

                          <div className="flex items-center gap-4">
                            <span className="table-header">
                              {associate?.status}
                            </span>

                            <button
                              onClick={() =>
                                handleMinusButton(item._id, associate._id)
                              }
                              className="
                              w-7
                              h-7
                              rounded-full
                              flex
                              items-center
                              justify-center
                              transition-all
                              duration-300
                              hover:bg-[rgba(184,56,56,0.14)]
                            "
                            >
                              <img
                                src={crossIcon}
                                alt="crossIcon"
                                className="w-3 h-3"
                              />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* ========================================= */}
        {/* RIGHT PANEL */}
        {/* ========================================= */}

        <div
          className="
          card
          overflow-hidden
          transition-all
          duration-500
          hover:shadow-[var(--shadow-card-hover)]
          h-fit
          sticky
          top-4
        "
        >
          <DescriptionBox
            title="MANAGE STORES"
            subTitle="Send Store Access"
            description="Assign reports & permissions"
          />

          {/* BODY */}
          <div className="mt-6 flex flex-col gap-5">
            {rightLoader ? (
              <div
                className="
                flex
                items-center
                justify-center
                py-20
              "
              >
                <ProgressSpinner
                  style={{
                    width: "60px",
                    height: "60px",
                  }}
                  strokeWidth="2"
                />
              </div>
            ) : (
              <>
                <div className="flex flex-col gap-2">
                  <label className={labelClass}>Select Stores</label>

                  <SelectStore
                    storesFetched={storesFetched}
                    selectedStores={selectedStores}
                    onSelectionChange={handleSelectionChange}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className={labelClass}>First Name</label>

                  <InputText
                    type="text"
                    placeholder="First Name"
                    className={inputClass}
                    value={associateInfo?.firstName}
                    disabled={selectedStores?.length === 0}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className={labelClass}>Last Name</label>

                  <InputText
                    type="text"
                    placeholder="Last Name"
                    className={inputClass}
                    value={associateInfo?.lastName}
                    disabled={selectedStores?.length === 0}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className={labelClass}>Email</label>

                  <InputText
                    type="text"
                    placeholder="Email"
                    className={inputClass}
                    value={associateInfo?.email}
                    ref={EmailInput}
                    disabled={selectedStores?.length === 0}
                  />
                </div>

                <div className="flex flex-col gap-2">
                  <label className={labelClass}>Message</label>

                  <InputTextarea
                    className={`
                      w-full min-h-[90px] rounded-md px-3 py-2.5
                      border border-[rgb(var(--border-primary))]
                      bg-[rgb(var(--surface-2))]
                      text-[12px] text-[rgb(var(--text-primary))]
                      placeholder:text-[rgb(var(--text-muted))]
                      resize-none focus:shadow-none
                      focus:border-[rgba(212,168,74,0.5)]
                      transition-colors duration-200
                    `}
                    placeholder="Write your message..."
                    ref={messageInput}
                  />
                </div>

                <AppButton
                  onClick={handleSendingStoreReportAccess}
                  appVariant="primary"
                  loading={rightLoader}
                >
                  {!sendBtnText ? "Send Access" : "Update Access"}
                </AppButton>

                <p
                  className="
                  text-center
                  text-[11px]
                  leading-[1.8]
                  text-[rgb(var(--text-muted))]
                  mt-1
                "
                >
                  Associates will only be able to access reports for selected
                  stores.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageStore;
